export const barcos = {
    H: "Sou o elemento mais leve e abundante do universo.",
    He: "Sou um gás nobre que faz sua voz ficar engraçada.",
    Li: "Sou usado em baterias recarregáveis.",
    Be: "Sou tóxico e usado em esmeraldas.",
    B: "Sou um semimetal usado em detergentes.",
    C: "Sou a base da vida e posso ser diamante ou grafite.",
    N: "Sou o principal componente do ar atmosférico.",
    O: "Sou essencial para a respiração.",
    F: "Sou o halogênio mais reativo e protejo seus dentes.",
    Ne: "Sou um gás nobre que brilha em vermelho nas placas luminosas.",
    Na: "Sou um metal alcalino usado para dar sabor à comida.",
    Mg: "Sou usado em fogos de artifício roxos.",
    Al: "Sou usado em latas de refrigerante e papel alumínio.",
    Si: "Sou usado em chips de computador e painéis solares.",
    P: "Sou encontrado nos ossos e DNA.",
    S: "Tenho cheiro de ovo podre quando combinado com hidrogênio.",
    Cl: "Sou parte do sal de cozinha e estou no grupo 17.",
    Ar: "Sou um gás nobre usado em lâmpadas fluorescentes.",
    K: "Sou um metal alcalino encontrado em bananas.",
    Ca: "Sou essencial para ossos e dentes fortes.",
    Sc: "Sou um metal de transição usado em equipamentos esportivos.",
    Ti: "Sou forte como o aço, mas muito mais leve.",
    V: "Sou usado para fazer aço mais resistente.",
    Cr: "Dou brilho aos metais e sou usado em cromagem.",
    Mn: "Sou essencial para a fotossíntese.",
    Fe: "Sou essencial para o sangue e ferroso.",
    Co: "Sou usado em ímãs poderosos.",
    Ni: "Sou usado em moedas e baterias recarregáveis.",
    Cu: "Sou usado em fios elétricos e tenho cor avermelhada.",
    Zn: "Sou usado para galvanizar ferro e prevenir ferrugem.",
    Ga: "Sou líquido em dias quentes e usado em LEDs.",
    Ge: "Fui usado nos primeiros transistores.",
    As: "Sou um metaloide tóxico famoso em histórias de crime.",
    Se: "Sou essencial para o corpo humano em pequenas quantidades.",
    Br: "Sou um líquido vermelho-marrom à temperatura ambiente.",
    Kr: "Sou um gás nobre usado em algumas lâmpadas.",
    Rb: "Sou um metal alcalino altamente reativo que brilha no escuro.",
    Sr: "Sou usado para fazer fogos de artifício vermelhos.",
    Y: "Sou usado em LEDs que emitem luz branca.",
    Zr: "Sou resistente à corrosão e usado em reatores nucleares.",
    Nb: "Sou usado em ímãs supercondutores.",
    Mo: "Sou usado para fortalecer ligas de aço.",
    Tc: "Sou o primeiro elemento radioativo artificial.",
    Ru: "Sou um metal precioso usado em eletrônica.",
    Rh: "Sou usado em conversores catalíticos de automóveis.",
    Pd: "Sou usado em joias e dispositivos eletrônicos.",
    Ag: "Sou um metal precioso usado em fotografias e joias.",
    Cd: "Sou tóxico e usado em algumas baterias.",
    In: "Sou usado em telas sensíveis ao toque.",
    Sn: "Sou usado em latas de conserva e soldas.",
    Sb: "Sou usado para tornar plásticos resistentes ao fogo.",
    Te: "Sou um semimetal usado em painéis solares.",
    I: "Sou essencial para a tireoide e usado como antisséptico.",
    Xe: "Sou um gás nobre usado em flashes fotográficos.",
    Cs: "Sou usado em relógios atômicos.",
    Ba: "Sou usado em exames de raio-X do sistema digestivo.",
    La: "Sou usado em lentes de câmeras de alta qualidade.",
    Ce: "Sou usado para polir vidros e lentes.",
    Pr: "Sou usado em ímãs fortes e óculos de proteção.",
    Nd: "Sou usado em ímãs muito potentes.",
    Pm: "Sou um elemento radioativo artificial.",
    Sm: "Sou usado em lasers e ímãs de samário-cobalto.",
    Eu: "Sou usado para criar a cor vermelha em TVs.",
    Gd: "Sou usado em ressonância magnética.",
    Tb: "Sou usado em telas verdes fluorescentes.",
    Dy: "Sou usado em discos rígidos de computador.",
    Ho: "Tenho o nome de uma cidade escandinava.",
    Er: "Sou usado para amplificar sinais em fibra ótica.",
    Tm: "Sou um dos elementos terras raras mais raros.",
    Yb: "Sou usado em relógios atômicos de íterbio.",
    Lu: "Sou o último elemento da série dos lantanídeos.",
    Hf: "Sou usado em filamentos de alta temperatura.",
    Ta: "Sou usado em equipamentos cirúrgicos.",
    W: "Sou usado em filamentos de lâmpadas.",
    Re: "Sou um dos elementos mais densos conhecidos.",
    Os: "Sou o elemento natural mais denso.",
    Ir: "Sou o elemento mais resistente à corrosão.",
    Pt: "Sou um metal precioso usado em joias e catalisadores.",
    Au: "Sou um metal precioso amarelo usado em joias.",
    Hg: "Sou o único metal líquido à temperatura ambiente.",
    Tl: "Sou tóxico e usado em detectores de radiação.",
    Pb: "Fui muito usado em tintas e gasolina no passado.",
    Bi: "Sou usado em medicamentos para o estômago.",
    Po: "Sou um elemento radioativo descoberto por Marie Curie.",
    At: "Sou o halogênio mais raro e radioativo.",
    Rn: "Sou um gás nobre radioativo.",
    Fr: "Sou o metal alcalino mais raro e radioativo.",
    Ra: "Sou radioativo e brilho no escuro.",
    Ac: "Sou o primeiro elemento da série dos actinídeos.",
    Th: "Sou usado como combustível nuclear alternativo.",
    Pa: "Sou um metal radioativo prateado.",
    U: "Sou usado como combustível em usinas nucleares.",
    Np: "Sou um elemento artificial usado em detectores de nêutrons.",
    Pu: "Sou usado em armas nucleares e geração de energia.",
    Am: "Sou usado em detectores de fumaça.",
    Cm: "Sou usado em geradores termoelétricos.",
    Bk: "Fui nomeado em homenagem a Berkeley.",
    Cf: "Sou usado para iniciar reações nucleares.",
    Es: "Fui descoberto nos restos de uma bomba de hidrogênio.",
    Fm: "Fui nomeado em homenagem a Enrico Fermi.",
    Md: "Fui nomeado em homenagem a Mendeleev.",
    No: "Fui nomeado em homenagem a Alfred Nobel.",
    Lr: "Sou o último elemento da série dos actinídeos.",
    Rf: "Sou um elemento sintético do grupo 4.",
    Db: "Fui nomeado em homenagem a Dubnium.",
    Sg: "Fui nomeado em homenagem a Seaborg.",
    Bh: "Sou um elemento sintético do grupo 7.",
    Hs: "Fui nomeado em homenagem ao estado de Hesse.",
    Mt: "Sou um elemento sintético do grupo 9.",
    Ds: "Fui nomeado em homenagem a Darmstadt.",
    Rg: "Sou um elemento sintético do grupo 11.",
    Cn: "Sou um elemento sintético do grupo 12.",
    Nh: "Sou um elemento sintético do grupo 13.",
    Fl: "Sou um elemento sintético do grupo 14.",
    Mc: "Sou um elemento sintético do grupo 15.",
    Lv: "Sou um elemento sintético do grupo 16.",
    Ts: "Sou um elemento sintético do grupo 17.",
    Og: "Sou o último elemento sintético conhecido."
};